export default __webpack_public_path__ + "static/media/logoVertikal.2749a5ca.png";